import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=95fb8f54&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=ts"
export * from "./shopDetails.vue?vue&type=script&lang=ts"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=95fb8f54&prod&lang=less"
import style1 from "./shopDetails.vue?vue&type=style&index=1&id=95fb8f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fb8f54",
  null
  
)

export default component.exports